import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  hero: {
    background: 'linear-gradient(180deg, #4C1D95 0%, #6D28D9 100%)',
    padding: theme.spacing(5, 6, 0, 6),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(3.5, 2.5, 0, 2.5)
    }
  } as SxProps,

  stepperWrapper: {
    paddingTop: theme.spacing(4),
    width: '100%',
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(2)
    }
  } as SxProps,

  stepperCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px 16px 0 0',
    height: 88,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0, 6),
    [theme.breakpoints.down('md')]: {
      height: 80,
      padding: theme.spacing(0, 2.5)
    }
  } as SxProps,

  stepRow: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(1.5)
  } as SxProps,

  card: {
    borderRadius: '12px',
    padding: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
    backgroundColor: '#FFFFFF',
    boxShadow: '0px 1px 4px rgba(0,0,0,0.04)',
    width: '100%',
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2),
      gap: theme.spacing(2)
    }
  } as SxProps,

  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  } as SxProps,

  iconWrap: {
    width: 32,
    height: 32,
    borderRadius: '8px',
    flexShrink: 0
  } as SxProps,

  avatarRow: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.75),
    padding: theme.spacing(2, 0)
  } as SxProps,

  avatarCircle: {
    width: 48,
    height: 48,
    minWidth: 48,
    borderRadius: '50%',
    flexShrink: 0
  } as SxProps,

  divider: {
    height: 1,
    backgroundColor: theme.palette.grey[200],
    width: '100%'
  } as SxProps,

  infoRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    width: '100%'
  } as SxProps,

  infoIconWrap: {
    width: 32,
    height: 32,
    minWidth: 32,
    borderRadius: '8px',
    flexShrink: 0
  } as SxProps,

  infoContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1
  } as SxProps,

  orderGrid: {
    display: 'flex',
    gap: theme.spacing(1.5),
    width: '100%'
  } as SxProps,

  orderDataBox: {
    borderRadius: '10px',
    padding: theme.spacing(1.75, 2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    flex: 1
  } as SxProps,

  itemsBadge: {
    borderRadius: '13px',
    height: 26,
    width: 56,
    flexShrink: 0
  } as SxProps,

  itemRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(2, 0)
  } as SxProps,

  itemImgBox: {
    width: 54,
    height: 54,
    minWidth: 54,
    borderRadius: '10px',
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
      width: 52,
      height: 52,
      minWidth: 52
    }
  } as SxProps,

  itemInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
    flex: 1
  } as SxProps,

  itemMeta: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    flexWrap: 'wrap'
  } as SxProps,

  chip: {
    height: 24,
    borderRadius: '6px',
    width: 72
  } as SxProps
}

export default styles
